<template>
  <div>
    <Breadcrumb style="margin: 20px 10%;font-size: 18px;">
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem to="/innovation">科研创新</BreadcrumbItem>
      <BreadcrumbItem>研究项目与成果</BreadcrumbItem>
    </Breadcrumb>
    <div class="infoDiv" v-if="nowP">
      <div class="title">{{ nowP.title }}</div>
      <div class="content">
        <p class="stitle">项目简介：</p>
        <div class="words">
          {{ nowP.target }}
        </div>

        <p class="stitle">研究重点：</p>
        <div class="words">
          <ul>
            <li v-for="(item, index) in nowP.progress" :key="index">
              <div>
                <div style="font-weight:bold;">
                  重点{{
                    index + 1 == 1 ? "一" : index + 1 == 2 ? "二" : "三"
                  }}：
                </div>
                <p style="margin: 10px 0;">{{ item.describe }}</p>
                <img :src="item.img" alt="" style="width:500px;" />
              </div>
            </li>
          </ul>
        </div>

        <p class="stitle">主要成果：</p>
        <div class="words">
          <ul>
            <li>
              <div>
                <div style="font-weight:bold;">研究报告：</div>
                <img v-for="item in patents1" :src="item" alt="" :key="item" />
              </div>
            </li>
            <li>
              <div>
                <div style="font-weight:bold;">申请专利：</div>
                <img v-for="item in patents2" :src="item" alt="" :key="item" />
              </div>
            </li>
            <li>
              <div>
                <div style="font-weight:bold;">发表论文：</div>
                <img v-for="item in patents3" :src="item" alt="" :key="item" />
              </div>
            </li>
          </ul>
        </div>

        <p class="stitle">参与人员：</p>
        <div class="words">
          <div>
            项目负责：<span>{{ nowP.leader }}</span>
          </div>
          <div>
            项目组成员：
            <span
              v-for="man in nowP.participants"
              :key="man"
              @click="toParticipants(man.id)"
              >{{ man.name }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div style="text-align:center;width:100%;font-size:30px;height:300px;" v-else>
      暂未录入项目信息
    </div>
  </div>
</template>
<script>
export default {
  name: "innovation_detail",
  components: {},
  data() {
    return {
      project: [
        {
          id: 1,
          title: "区域级SHM融合云平台关键技术研发",
          progress: [
            {
              describe:
                "基于云计算和健康监测预警与评估算法体系，提供区域级工程安全监测预警的“集中式”运维服务，成为智慧城市、智慧交通的重要分支",
              img:
                "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_tech3.png"
            },
            {
              describe:
                "融合BIM模型网页化等技术，提升大数据人机交互效率，为工程管理决策提供强大支持",
              img:
                "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_tech2.png"
            },
            {
              describe:
                "从工程项目管理的实际出发，为工程单位的各种需求搭建信息管理系统，提供优质的研发和升级服务",
              img:
                "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_tech1.png"
            }
          ],
          target:
            "针对区域级SHM系统需求，研发“物美价廉”的监测大数据平台（监测平台、运维平台、研究平台）",
          achievements: "专利x篇  论文x篇",
          plan:
            "迭代开发运维平台，新增自动报告生成、无人机专项监测、车辆荷载效应分析、三维实景模型展示等功能。",
          leader: "郑淳",
          participants: [{name: "苏仁智", id: 999}, {name: "龙振佳", id: 888}, {name: "骆泓杰", id: 777}, {name: "何增胜", id: 1}]
        }
      ],
      patents1: [
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/patent1.png",
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/patent5.png"
      ],
      patents2: [
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/patent2.png",
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/patent6.png"
      ],
      patents3: [
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/patent3.png",
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/patent4.png",
        "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/patent7.png"
      ],
      idNum: 1,
      nowP: null
    }
  },
  created() {
    let id = this.$route.query.id
    
    if (id) {
      this.idNum = id
      this.nowP = this.project.find(item => item.id == this.idNum)
    } else {
      this.$emit("changeProduce", "innovation")
    }
  },
  methods: {
    toParticipants(id) {
      if(id < 100) this.$emit("changeProduce", "participants", null, id)
    }
  }
}
</script>
<style lang="less" scoped>
.infoDiv {
  width: 80%;
  margin: 0 auto;
  .title {
    display: block;
    width: 100%;
    font-size: 24px;
    text-align: center;
    font-weight: bolder;
    color: #000;
    line-height: 2em;
  }
  .content {
    width: 80%;
    margin: 0 auto 10px;
    .stitle {
      font-size: 18px;
      width: max-content;
      line-height: 1.5em;
      font-weight: bold;
      margin: 10px 0;
      border: 1px solid #dcdee2;
      // border-radius: 15px;
      background-color: #6699cc;
      color: #000;
    }
    .words {
      font-size: 18px;
      line-height: 1.5em;
      text-indent: 2em;
      margin: 10px 0;
      img {
        width: 200px;
        margin: 0 10px;
      }
      span {
        margin: 0 20px;
        text-decoration: underline;
      }
      span:hover {
        color: blue;
        cursor: pointer;
      }
      div {
        margin: 10px 0;
        img {
          // display: block;
          width: 200px;
        }
      }
    }
  }
}
</style>
